import React from 'react';
import {
  Typography,
  Button,
  InputBase,
  FormControl,
  InputLabel,
} from '@mui/material';
import api from '~/_base/constants/api';
import useSWR from 'swr';
import { Customer } from './app';
import FormControlError from '~/_base/components/formControlError';
import { useForm } from 'react-hook-form';

interface StepThreeProps {
  onNext: (data: Partial<Customer>) => void;
  formState: Partial<Customer>;
  onPrevious: () => void;
}

export default function StepThree({
  onNext,
  onPrevious,
  formState,
}: StepThreeProps) {
  const { register, handleSubmit, formState: { errors } } = useForm({
    reValidateMode: 'onSubmit',
  });

  const hostname = window.location.hostname
    .split('.')
    .map((s, i) => (i === 0 ? '' : s))
    .join('.');

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <Typography variant="h1" style={{ marginBottom: 24 }}>
        What sign in URL do you want?
      </Typography>
      <Typography variant="body2" style={{ margin: '24px 0' }}>
        Choose the address you'll use to log in to Damstra Forms
      </Typography>
      <FormControl
        variant="standard"
        required
        fullWidth
        error={errors.subdomain != null}
        style={{ marginBottom: 16 }}>
        {errors.subdomain && (
          <FormControlError
            message={
              errors.subdomain.type === 'pattern'
                ? 'Must only contain alpha-numeric characters'
                : errors.subdomain.type === 'minLength'
                ? 'Must be greater than 3 characters'
                : errors.subdomain.type === 'maxLength'
                ? 'Must be less than 60 characters'
                : 'The domain name is already in use, please choose another.'
            }
          />
        )}
        <InputLabel htmlFor="url">URL</InputLabel>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
          <InputBase
            id="url"
            autoFocus
            defaultValue={formState.subdomain}
            {...register('subdomain', {
              required: true,
              // https://stackoverflow.com/questions/7930751/regexp-for-subdomain
              pattern: /^[a-zA-Z0-9][a-zA-Z0-9.-]+[a-zA-Z0-9]$/,
              validate: async (val: string) => {
                if (val.trim() === '') return false;
                try {
                  await api.domainCheck.request(val.toLowerCase());
                  return true;
                } catch (err) {
                  return false;
                }
              },
              minLength: 3,
              maxLength: 60,
            })}
            onChange={e => {
              e.target.value = e.target.value
                .replace(/\s+/g, '-')
                .toLowerCase();
              // Call the register onChange
              register('subdomain').onChange?.(e);
            }}
            style={{ flex: 1 }}
            type="text"
            data-apedomain="apedomain"
            placeholder="e.g. Company Name"
          />
          <span>{hostname}</span>
        </div>
      </FormControl>
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button variant="contained" style={{ width: 120 }} onClick={onPrevious}>
          Previous
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ width: 120 }}
          type="submit"
        >
          Next
        </Button>
      </div>
    </form>
  );
}
